import { NgModule } from "@angular/core";
import { WidgetContainerComponent } from "./widget-container.component";
import { CommonModule } from "@angular/common";
import { WidgetContainerRoutingModule } from "./widget-container-routing.module ";
import { CustomModalModule } from "../shared/custom-modal/custom-modal.module";
import { PopupFestiveSaleModule } from "../popups/popup-festive-sale/popup-festive-sale.module";
import { PopupWinterSaleModule } from "../popups/popup-winter-sale/popup-winter-sale.module";

@NgModule({
  declarations: [WidgetContainerComponent],
  imports: [
    CommonModule,
    WidgetContainerRoutingModule,
    CustomModalModule,
    PopupFestiveSaleModule,
    PopupWinterSaleModule
  ],
  exports: [WidgetContainerComponent]
})
export class WidgetContainerModule {}
